import PropTypes from "prop-types";
import React,{useState} from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/logo2.png";
import logo from "assets/images/logo2.png";

const Login = props => {

  //meta title
  document.title = "Giriş | Berlin Esnaf - Admin Paneli";

  const [getIsActive, setIsActive] = useState(false);

  const [getMail, setMail] = useState(false);
  const [getPassword, setPassword] = useState(false);

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: getMail != null ? getMail : '',
      password: getPassword != null ? getPassword : '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Lütfen Mail Adresini Giriniz"),
      password: Yup.string().required("Lütfen Şifrenizi Giriniz"),
    }),
    onSubmit: (values) => {

      if(getIsActive == true){

        console.log("lsndfjlsd",values.email)
      localStorage.setItem("rememberMail",values.email);
      localStorage.setItem("rememberPassword",values.password);
      localStorage.setItem("rememberCheck", getIsActive);

      }
      
      dispatch(loginUser(values, props.router.navigate));
    }
  });

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));

  React.useEffect(() => {

    //localStorage.clear()
    let rememberMe = localStorage.getItem("rememberCheck");

    console.log("rememberMe123",rememberMe)
    if(rememberMe =="true"){
      let mailAdress = localStorage.getItem("rememberMail");
      let password1 = localStorage.getItem("rememberPassword");
    
      setIsActive(true)
      setMail(mailAdress)
      setPassword(password1)
    }else{

      setIsActive(true)

    }

  }, []);

    const signIn = type => {
        dispatch(socialLogin(type, props.router.navigate));
    };


    const toggleChange = () => {
      setIsActive((state) => (!state.isChecked));
    }
   
  const NAVY = "#141E46";
  const CREAM = "#FFF5E0";

  return (
    <React.Fragment>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: `linear-gradient(135deg, ${NAVY} 0%, #1f2d63 55%, #2a3a7a 100%)`,
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={9} lg={7} xl={5}>
              <Card
                className="overflow-hidden border-0"
                style={{ borderRadius: 18, boxShadow: "0 20px 60px rgba(0,0,0,0.35)" }}
              >
                {/* Üst marka bandı (logo içeride, tam görünür) */}
                <div
                  style={{
                    background: NAVY,
                    padding: "30px 24px 26px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: 92,
                      height: 92,
                      borderRadius: "50%",
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 14px",
                      boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
                      border: `3px solid ${CREAM}`,
                    }}
                  >
                    <img
                      src={logo}
                      alt="Berlin Esnaf"
                      style={{ width: 64, height: 64, borderRadius: "50%", objectFit: "contain" }}
                    />
                  </div>
                  <h4 style={{ color: "#fff", fontWeight: 700, marginBottom: 4, letterSpacing: 0.5 }}>
                    Berlin Esnaf
                  </h4>
                  <p style={{ color: CREAM, opacity: 0.85, marginBottom: 0, fontSize: 14 }}>
                    Yönetim Paneli
                  </p>
                </div>

                <CardBody className="px-4 pt-4 pb-4">
                  <div className="text-center mb-4">
                    <h5 style={{ color: NAVY, fontWeight: 700, marginBottom: 2 }}>Hoş Geldiniz 👋</h5>
                    <p className="text-muted mb-0" style={{ fontSize: 14 }}>
                      Devam etmek için giriş yapın
                    </p>
                  </div>

                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {error ? <Alert color="danger">{error}</Alert> : null}

                    <div className="mb-3">
                      <Label className="form-label" style={{ color: NAVY, fontWeight: 600 }}>
                        Mail Adresi
                      </Label>
                      <div className="position-relative">
                        <i
                          className="bx bx-envelope"
                          style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9aa0b5", fontSize: 18 }}
                        />
                        <Input
                          name="email"
                          className="form-control"
                          style={{ paddingLeft: 38, height: 46, borderRadius: 10 }}
                          placeholder="Mail Adresini Giriniz"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={validation.touched.email && validation.errors.email ? true : false}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="mb-3">
                      <Label className="form-label" style={{ color: NAVY, fontWeight: 600 }}>
                        Şifre
                      </Label>
                      <div className="position-relative">
                        <i
                          className="bx bx-lock-alt"
                          style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9aa0b5", fontSize: 18 }}
                        />
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          className="form-control"
                          style={{ paddingLeft: 38, height: 46, borderRadius: 10 }}
                          placeholder="Şifreyi Giriniz"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={validation.touched.password && validation.errors.password ? true : false}
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="rememberCheck"
                        defaultChecked={getIsActive}
                        value={getIsActive}
                        onChange={toggleChange}
                      />
                      <label className="form-check-label" htmlFor="rememberCheck">
                        Beni Hatırla
                      </label>
                    </div>

                    <div className="mt-4 d-grid">
                      <button
                        className="btn btn-block"
                        type="submit"
                        style={{
                          background: NAVY,
                          color: "#fff",
                          height: 48,
                          borderRadius: 10,
                          fontWeight: 600,
                          fontSize: 16,
                          border: "none",
                        }}
                      >
                        Giriş Yap
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p style={{ color: CREAM, opacity: 0.7, marginBottom: 0, fontSize: 13 }}>
                  © {new Date().getFullYear()} Berlin Esnaf — Tüm hakları saklıdır.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
